import '../main'
import Picker from './src/picker.vue'

Picker.install = function (Vue) {
    Vue.component(Picker.name, Picker)
}
export default Picker


// WEBPACK FOOTER //
// ./src/components/picker/index.js